import { render, staticRenderFns } from "./OzonConfigCompoment.vue?vue&type=template&id=119ff184"
import script from "./OzonConfigCompoment.vue?vue&type=script&lang=js"
export * from "./OzonConfigCompoment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports